// extracted by mini-css-extract-plugin
export default {"icon":"cells_icon__o039D","cell":"cells_cell__RN268","link":"cells_link__i6Lcz"};